import { PadWithZeroes } from "core/utils/Utils";

/**
 * core/utils/EditionUtils
 * ----------------------------------------------------------------------
 * Funções utilitárias para dados de edições da Glambox.
 *
 * @since     0.0.1
 */

/**
 * Lista com os nomes dos meses abreviados.
 *
 * @type {string[]}
 */
const MONTH_ABBR = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
  "Jul", "Ago", "Set", "Out", "Nov", "Dez"
];

/**
 * Lista com os nomes dos meses completos.
 *
 * @type {string[]}
 */
const MONTH_FULL = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

/**
 * Retorna o `editionId` para o feedback mais recente disponível.
 *
 * @param {boolean} isSuperbox
 *     Se superbox, ou não
 * @returns {string}
 */
export const GetEditionFeedbackId = (isSuperbox = false) => {
  let date = new Date(),
      subscriptionType = (isSuperbox === true) ? 2 : 1,
      month,
      year;

  year = date.getFullYear();
  if (date.getMonth() === 0) year -= 1;
  year = PadWithZeroes(year, 4);

  month = date.getMonth();
  if (month === 0) month = 12;
  month = PadWithZeroes(month, 4);

  return `${subscriptionType}${year}${month}`;
};

/**
 * Retorna a data da edição para o `editionId` fornecido.
 *
 * @param {number|string} editionId
 *     `editionId` de uma Glambox/Superbox
 * @param {boolean} abbr
 *     Se deve ser retornado com o nome abreviado, ou não
 * @param {string} separator
 *     Separador para mês/ano
 * @returns {string}
 */
export const GetEditionDateName = (
  editionId,
  abbr = false,
  separator = ", "
) => {
  if (typeof editionId !== "number") editionId = parseInt(editionId);

  let ano = parseInt(editionId / 100 % 10000, 10),
      mes = parseInt(editionId % 100, 10);
  
  return (abbr === true)
    ? MONTH_ABBR[mes - 1] + separator + ano
    : MONTH_FULL[mes - 1] + separator + ano;
};

/**
 * Retorna o nome e id/slug do status do rastreio para a edição desejada.
 *
 * @param {string|number} editionId
 *     `editionId` desejado
 * @param {number} editionStatusId
 *     Número representando o status da edição desejada
 * @param {boolean} isManuallyReceivedEdition
 *     Se a edição foi, ou não, enviada manualmente
 * @returns {object}
 */
export const GetTrackingStatus = (
  editionId,
  editionStatusId,
  isManuallyReceivedEdition = false,
) => {
  let title,
      id;

  if (
    editionId < 1201712
    || (editionId < 2201801 && editionId > 2201202)
    || isManuallyReceivedEdition === true
  ) {
    id = "entregue";
    title = "Entregue";
  } else {
    switch(editionStatusId) {
      case -1: // REMOVIDA/ESTORNADA
      case 0:
      case 9: // TESTE
        id = "confirmado";
        title = "Confirmado";
        break;
      case 1:
      case 2:
        id = "montagem";
        title = "Montagem";
        break;
      case 3:
      case 4:
        id = "coletada";
        title = "Retirada pela transportadora";
        break;
      case 6:
        id = "entregue";
        title = "Entregue";
        break;
      default:
        id = "emrota";
        title = "Em Rota";
        break;
    }
  }

  return { title, id };
};
